<template>
  <div class="customer">
    <img
      class="qrcode"
      src="https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/402b5fcbb8ec6f294d88c0034992d28f.png"
      alt=""
    />
    <div class="btn" @click="bindClick">添加客服</div>
  </div>
</template>
<script>
import sha1 from 'sha1'
export default {
  data() {
    return {
      urlScheme: '',
      wechatUrl:
        'https://work.weixin.qq.com/ca/cawcde8b32f46a0d59?customer_channel=qywx_ca:102381229'
    }
  },
  created() {
    // this.getUrlScheme();
  },
  mounted() {},
  methods: {
    bindClick() {
      location.href = this.wechatUrl
    },
    getUrlScheme() {
      let time = new Date().getTime()
      let permissionKey = 'welara_api_permission'
      let params = {
        permission_key: permissionKey,
        time,
        sign: sha1(permissionKey + time),
        path: 'pages/image-page/index?url=https%3A%2F%2Fcdnvue.gymcity.com.cn%2Fbetterwe_1.0%2Fvue%2F4169b29a7e3184265552364b13b3e50d.png&title=%E6%B7%BB%E5%8A%A0%E5%AE%A2%E6%9C%8D&backColor=#DDDDDF'
      }
      this.$http.postWeApi('api/getAideUrlScheme', params).then((res) => {
        res = res.data
        if (res.code == 200) {
          this.urlScheme = (res.data && res.data.openLink) || ''
        } else {
          this.$toast('获取链接失败')
        }
      })
    }
  }
}
</script>
<style lang="scss" scoped>
.customer {
  min-height: 100vh;
  background-color: #fff;
  .qrcode {
    width: 100%;
    height: 410px;
    object-fit: contain;
  }
  .btn {
    margin: 0 auto;
    width: 320px;
    height: 40px;
    font-size: 16px;
    font-weight: 600;
    line-height: 40px;
    color: #fff;
    background-color: rgb(151, 133, 253);
    text-align: center;
    border-radius: 10px;
  }
}
</style>
